module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr/address/postcode.js
// module id = 1178
// module chunks = 0